export const galleryOptions = {
    // dragToClose: false,
    // closeButton: 'outside',
    // template: {
    //     closeButton: `<i class="icon-close"></i>`,
    //     main: `
    //         <div class="fancybox__container" role="dialog" aria-modal="true" aria-hidden="true" aria-label="{{MODAL}}" tabindex="-1">
    //             <div class="fancybox__backdrop"></div>
    //             <div class="fancybox__carousel"></div>
    //         </div>
    //     `,
    // },
    Images: {
        zoom: false,
    },
    // Thumbs: {
    //     autoStart: false,
    // },
    // tpl: {
    //     // closeButton: `<i class="icon-close"></i>`,
    //     main: `
    //         <div class="fancybox__container" role="dialog" aria-modal="true" aria-hidden="true" aria-label="{{MODAL}}" tabindex="-1">
    //             <div class="fancybox__backdrop"></div>
    //             <img src="/site/buildpro/dist/images/logo.svg" class="fancy-logo">

    //             <div class="fancybox__carousel"></div>
    //         </div>
    //     `,
    // },
    Toolbar: {
        display: {
            left: [],
            middle: [],
            right: ["close"],
        },
        items: {
            // prev: {
            //     tpl: `<button class="f-button f-button-close" title="{{CLOSE}}" data-fancybox-close>
            //         <i class="icon-close"></i>
            //     </button>`,
            // },
            // next: {
            //     tpl: `<button class="f-button f-button-close" title="{{CLOSE}}" data-fancybox-close>
            //         <i class="icon-close"></i>
            //     </button>`,
            // },
            // close: {
            //     tpl: `<button class="f-button f-button-close" title="{{CLOSE}}" data-fancybox-close>
            //         <i class="icon-close"></i>
            //     </button>`,
            // },
        },
    },
    Carousel: {
        Navigation: {
            prevTpl: `<i class="icon-arrow-medium-left">`,
            nextTpl: `<i class="icon-arrow-medium-right">`,
        }
    },
}

export default galleryOptions;